import * as React from 'react'

import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';

import './styles.css';

interface Props {
  success: boolean,
  text: string,
  show: boolean,
  close: () => void,
}

export default (props: Props) => {
  const closeAfter = 5000; // 5s

  props.show && setTimeout(() => {
    props.close();
  }, closeAfter);

  return (
    <React.Fragment>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 0,
          alignItems: 'flex-start',
          flexWrap: 'wrap-reverse'
        }}
      >
        <Fade>
          {props.show && <Notification
              type={{ style: props.success ? 'success' : 'error', icon: true }}
              closable={true}
              onClose={props.close}
          >
              <span>{props.text}</span>
          </Notification>}
        </Fade>
      </NotificationGroup>
    </React.Fragment>
  );
}
